<template>
  <ul class="skip-links">
    <li>
      <UILinkComponent
        to="#main"
        class="screen-reader-shortcut"
        tabindex="1"
      >
        Door naar de hoofd inhoud
      </UILinkComponent>
    </li>
    <li>
      <UILinkComponent
        class="screen-reader-shortcut"
        to="#footer"
        tabindex="2"
      >
        Spring naar de voettekst
      </UILinkComponent>
    </li>
    <li>
      <UILinkComponent
        to="#nav-wrapper"
        class="screen-reader-shortcut"
        tabindex="3"
      >
        Naar navigatie
      </UILinkComponent>
    </li>
  </ul>
</template>
